import React, { useMemo } from 'react';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import Button from '../../components/shared/buttons/Button';
import Row from '../../components/shared/table/Row';
import SelectableRow from '../../components/shared/table/SelectableRow';
import Table from '../../components/shared/table/Table';
import { formatPrice } from '../../utils/formatter';

const RatesTable = ({ rates, loading, onRateClick, onRateDeleteClick, readOnly }) => {
  const tableRows = useMemo(
    () =>
      rates.map((rate, i) => (
        <SelectableRow key={i} onClick={() => onRateClick(rate)}>
          <Row children={rate.name} />
          <Row children={formatPrice(rate.price)} />
          {!readOnly && (
            <Row
              children={
                <div title="Видалити" className="w-full text-end z-10">
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                      onRateDeleteClick(rate);
                    }}
                    variant="secondary2"
                    disabled={loading}
                  >
                    <MdOutlineDeleteOutline size={20} />
                  </Button>
                </div>
              }
            />
          )}
        </SelectableRow>
      )),
    [readOnly, onRateDeleteClick, loading, rates, onRateClick],
  );

  return <Table columns={readOnly ? readOnlyColumns : columns} data={tableRows} onRowClick={() => ({})} />;
};

const readOnlyColumns = [
  { name: 'Назва', className: 'w-[90%]' },
  { name: 'Вартість', className: 'w-[10%]' },
];

const columns = [
  { name: 'Назва', className: 'w-[80%]' },
  { name: 'Вартість', className: 'w-[15%]' },
  { name: 'Дії', className: 'w-[5%] text-center' },
];

export default RatesTable;
